// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1ry_X","buttons":"SendReceipts_buttons__3Ji8p","email":"SendReceipts_email__1tbxf","bookApptTitle":"SendReceipts_bookApptTitle__1oRQv"};